import React, { useEffect, useState } from "react";
import { Modal, TextArea, Button, Toast } from "@douyinfe/semi-ui";
import { AiCoachApi, AiCoachCreateActionReq } from "../../api/aiCoach";

interface Props {
  reportId: number;
  adjustmentIndex: number;
  defaultAction: string;
  onClose: () => void;
  onSaved: () => void;
}

const ActionModal: React.FC<Props> = ({
  reportId,
  adjustmentIndex,
  defaultAction,
  onClose,
  onSaved,
}) => {
  const [text, setText] = useState(defaultAction);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setText(defaultAction);
  }, [defaultAction]);

  const handleSave = async () => {
    if (!text.trim()) {
      Toast.warning("请录入执行计划");
      return;
    }
    setSaving(true);
    try {
      const req: AiCoachCreateActionReq = {
        adjustmentIndex,
        plannedAction: text.trim(),
      };
      await AiCoachApi.createAction(reportId, req);
      Toast.success("已接受为行动");
      onSaved();
    } catch (e) {
      Toast.error("保存失败");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title="接受为行动"
      visible
      onCancel={onClose}
      footer={
        <>
          <Button onClick={onClose}>取消</Button>
          <Button theme="solid" type="primary" loading={saving} onClick={handleSave}>
            保存
          </Button>
        </>
      }
    >
      <TextArea
        value={text}
        onChange={setText}
        autosize={{ minRows: 3 }}
        placeholder="请录入你的执行计划"
      />
    </Modal>
  );
};

export default ActionModal;
